import React, {Component} from 'react';
import './ContactBlock.css';

export default class ContactBlock extends Component {
    handleChatLinkClick() {
        try {
            window.$zopim.livechat.window.show();
        } catch (e) { }
    }

    render() {
        return (
            <div className={"ContactBlock"}>
                <div className="block-footer__inner">
                    <p className="block-footer__intro">Hulp nodig bij het gebruik van de planning tools?</p>

                    <div className="support-option">
                        <i className="support-option__icon mdi mdi-message-text-outline"></i>
                        <a onClick={this.handleChatLinkClick.bind(this)}
                           className="support-option__label">Vraag het op de chat, ma-vr (09:00-17:00) <i
                            className="mdi mdi-arrow-right"></i></a>
                    </div>

                    <div className="support-option">
                        <i className="support-option__icon mdi mdi-phone-in-talk"></i>
                        <span className="support-option__label">Bel 010 820 97 53, ma-vr (09:00-17:00)</span>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Portal/Parts/ContactBlock.js